import Vue from 'vue'

const OperationEventBus = new Vue()

export default OperationEventBus
